import request from '../utils/request';
import { stringify } from 'qs';

export async function getGameList (params: object) {
  return request(`/api/user/attach/game/list?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params
  })
}

export async function getHistoryList(params: object) {
  return request(`/api/user/attach/history?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params
  })
}

// 开始上传

export async function uploadBegin(params: object) {
  return request(`/api/user/attach/upload/begin`, {
    method: 'POST',
    requestType: 'form',
    data: params
  })
}

// 上传完成
export async function uploadEnd(params: object) {
  return request(`/api/user/attach/upload/end`, {
    method: 'POST',
    requestType: 'form',
    data: params
  })
}
// 清楚记录
export async function clearHistory(params: object) {
  return request(`/api/user/attach/history/clear?${stringify(params)}`, {
    method: 'DELETE',
    requestType: 'form',
    data: params
  })
}
// 删除游戏
export async function deleteGame(params: object) {
  return request(`/api/user/attach/delete?${stringify(params)}`, {
    method: 'DELETE',
    requestType: 'form',
    data: params
  })
}

